import { render, staticRenderFns } from "./ManagersTab.vue?vue&type=template&id=0c547f96"
import script from "./ManagersTab.vue?vue&type=script&lang=js"
export * from "./ManagersTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports